import { SEND_MESSAGE_REQUEST, SEND_MESSAGE_SUCCESS, SEND_MESSAGE_FAILURE } from './actions'

export interface IMessagesState {
  loading: boolean
  error: string | null
}

const initialState: IMessagesState = {
  loading: false,
  error: null,
}

interface IMessageAction {
  type: string
  error: string
}

export default function messagesReducer(
  state = initialState,
  action: IMessageAction,
): IMessagesState {
  switch (action.type) {
    case SEND_MESSAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case SEND_MESSAGE_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case SEND_MESSAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      }
    default:
      return state
  }
}
